<template>
    <div class="admin-code">
      <div v-if="!displayContainerRubetekRV3434 && !displayContainerSokol" class="admin-code__section">
        <h2 class="admin-code__section-title">
          <v-icon left small>mdi-monitor-dashboard</v-icon>
          Настройки экрана
        </h2>
        <v-row class="admin-code__form-row">
          <v-col v-if="$checkPermission('update_text_doorphone')" cols="12" md="4" class="admin-code__col">
            <v-checkbox
              v-model="textDoorphoneEnabled"
              label="Отображение текста на домофоне"
              hide-details
              dense
              color="primary"
            />
          </v-col>
          <v-col v-if="$checkPermission('update_text_doorphone')" cols="12" md="4" class="admin-code__col">
            <v-text-field
              ref="textDoor"
              :rules="rules.textDoor"
              v-model="textDoorphone"
              label="Текст на домофоне"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col v-if="$checkPermission('update_text_doorphone')" cols="12" md="4" class="admin-code__col d-flex align-center">
            <v-btn
              color="primary"
              class="text-none"
              dark
              rounded
              :loading="isLoadingBtnMessage"
              @click="changeTextDoorphone()"
            >
              <v-icon left>mdi-pencil</v-icon>
              Изменить
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div class="admin-code__section mt-4">
        <div class="admin-code__section-header">
          <h2 class="admin-code__section-title">
            <v-icon left small>mdi-lock-outline</v-icon>
            Настройки кода открытия двери
          </h2>
          <v-menu v-if="$checkPermission('import_main_setups')" bottom left offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                outlined
                class="text-none"
                rounded
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-import</v-icon>
                Импорт из девайса
              </v-btn>
            </template>
            <v-list width="280" dense>
              <v-list-item @click.prevent="importCodes()">
                <v-list-item-icon><v-icon small>mdi-import</v-icon></v-list-item-icon>
                <v-list-item-title>Импорт из девайса</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-form v-if="doorphoneEditInfo.doorphone.model === 'RV-3438'" ref="formEditDoors" v-model="validDoors" lazy-validation class="admin-code__card mt-3">
            <div class="admin-code__card-body pa-4">
                <v-row class="admin-code__form-row">
                    <v-col cols="12" sm="6" md="4" class="admin-code__col">
                    <v-text-field
                        :rules="rules.code"
                        type="number"
                        label="Код открытия №1"
                        v-model="formDoors.code[0]"
                        outlined
                        dense
                        hide-details
                    />
                    </v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[0]" value="1" label="Замок №1" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[0]" value="2" label="Замок №2" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[0]" value="3" label="Замок №3" hide-details dense color="primary" /></v-col>
                </v-row>
                <v-row class="admin-code__form-row">
                    <v-col cols="12" sm="6" md="4" class="admin-code__col">
                    <v-text-field
                        :rules="rules.code"
                        type="number"
                        label="Код открытия №2"
                        v-model="formDoors.code[1]"
                        outlined
                        dense
                        hide-details
                    />
                    </v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[1]" value="1" label="Замок №1" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[1]" value="2" label="Замок №2" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[1]" value="3" label="Замок №3" hide-details dense color="primary" /></v-col>
                </v-row>
                <v-row class="admin-code__form-row">
                    <v-col cols="12" sm="6" md="4" class="admin-code__col">
                    <v-text-field
                        :rules="rules.code"
                        type="number"
                        label="Код открытия №3"
                        v-model="formDoors.code[2]"
                        outlined
                        dense
                        hide-details
                    />
                    </v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[2]" value="1" label="Замок №1" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[2]" value="2" label="Замок №2" hide-details dense color="primary" /></v-col>
                    <v-col cols="12" sm="6" md="2" class="admin-code__col d-flex align-center">
                    <v-checkbox v-model="formDoors.relay[2]" value="3" label="Замок №3" hide-details dense color="primary" /></v-col>
                </v-row>
                <v-row class="admin-code__form-row">
                  <v-col cols="12" class="admin-code__col pt-0">
                    <service-door-code-lifetime
                      ref="serviceCodeLifetimeRv3438"
                      :enabled="rotationEnabled"
                      :date="lifetimeDate"
                      :rotate-at="doorCodeRotateAt"
                      :comment="rotationComment"
                      @update:enabled="rotationEnabled = $event"
                      @update:date="lifetimeDate = $event"
                      @update:comment="rotationComment = $event"
                    />
                  </v-col>
                </v-row>
                <div class="admin-code__actions mt-3">
                    <v-btn type="button" color="primary" class="text-none" rounded @click="validateCodeData()">
                        <v-icon left>mdi-content-save-outline</v-icon>
                        Сохранить
                    </v-btn>
                    <v-btn color="primary" outlined class="text-none rounded ml-2" @click.prevent="returnDoorphone">
                        <v-icon left>mdi-close</v-icon>
                        Отменить
                    </v-btn>
                </div>
            </div>
        </v-form>
      <div v-if="displayContainerBeward" class="admin-code__section mt-4">
        <div class="admin-code__card pa-4">
          <v-row class="admin-code__form-row">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="serviceDoorCode"
                type="number"
                label="Сервисный код открытия двери"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn color="primary" class="text-none" dark rounded @click="changeCodeBeward()">
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
            <v-col cols="12" class="admin-code__col pt-0">
              <service-door-code-lifetime
                ref="serviceCodeLifetimeBeward"
                :enabled="rotationEnabled"
                :date="lifetimeDate"
                :rotate-at="doorCodeRotateAt"
                :comment="rotationComment"
                @update:enabled="rotationEnabled = $event"
                @update:date="lifetimeDate = $event"
                @update:comment="rotationComment = $event"
              />
            </v-col>
          </v-row>
          <v-row class="admin-code__form-row">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="scanByCode"
                :rules="[v => (v && v >= minServiceCode && v <= maxServiceCode) || 'число должно быть 5-значным']"
                type="number"
                label="Код сканирования RFID"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn color="primary" class="text-none" dark rounded @click="changeScanByCode()">
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="displayContainerRubetekRV3434" class="admin-code__section mt-4">
        <div class="admin-code__card pa-4">
          <v-row class="admin-code__form-row">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="serviceDoorCode"
                type="number"
                label="Сервисный код открытия двери"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn color="primary" class="text-none" dark rounded @click="changeCodeRubetek3434()">
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
            <v-col cols="12" class="admin-code__col pt-0">
              <service-door-code-lifetime
                ref="serviceCodeLifetimeRv3434"
                :enabled="rotationEnabled"
                :date="lifetimeDate"
                :rotate-at="doorCodeRotateAt"
                :comment="rotationComment"
                @update:enabled="rotationEnabled = $event"
                @update:date="lifetimeDate = $event"
                @update:comment="rotationComment = $event"
              />
            </v-col>
          </v-row>
          <l-c-d-settings />
        </div>
      </div>
      <div v-if="displayContainerSokol" class="admin-code__section mt-4">
        <div class="admin-code__card pa-4">
          <v-row class="admin-code__form-row">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="serviceDoorCode"
                type="number"
                label="Код открытия"
                hint="5 цифр, общий код открытия двери"
                persistent-hint
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn color="primary" class="text-none" dark rounded @click="changeOpeningCodeSokol()">
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
            <v-col cols="12" class="admin-code__col pt-0">
              <service-door-code-lifetime
                ref="serviceCodeLifetimeSokol"
                :enabled="rotationEnabled"
                :date="lifetimeDate"
                :rotate-at="doorCodeRotateAt"
                :comment="rotationComment"
                @update:enabled="rotationEnabled = $event"
                @update:date="lifetimeDate = $event"
                @update:comment="rotationComment = $event"
              />
            </v-col>
          </v-row>
          <v-row class="admin-code__form-row mt-2">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="servicePass"
                type="number"
                label="Сервисный код"
                hint="6 цифр, пароль сервисного режима"
                persistent-hint
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn
                color="primary"
                class="text-none"
                dark
                rounded
                :loading="loadingServicePass"
                @click="changeServicePass()"
              >
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="!displayContainerSokol" class="admin-code__section mt-4">
        <h2 class="admin-code__section-title">
          <v-icon left small>mdi-phone-classic</v-icon>
          Номер консьержа
        </h2>
        <div class="admin-code__card pa-4">
          <v-row class="admin-code__form-row">
            <v-col cols="12" sm="6" md="4" class="admin-code__col">
              <v-text-field
                v-model="conciergeNumber"
                type="text"
                label="Номер консьержа"
                outlined
                dense
                hide-details
              />
              <p v-if="conciergeNumberError" class="error--text text-caption mt-1 mb-0">Ошибка: {{ conciergeNumberError }}</p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="admin-code__col d-flex align-center">
              <v-btn
                color="primary"
                class="text-none"
                dark
                rounded
                :loading="loadingConciergeNumber"
                @click="changeConciergeNumber()"
              >
                <v-icon left>mdi-pencil</v-icon>
                Изменить
              </v-btn>
            </v-col>
          </v-row>
          <p v-if="agentDispatcherPhone" class="text-body-2 mt-3 mb-0">
            Номер диспетчерской агента: <strong>{{ agentDispatcherPhone }}</strong>
          </p>
        </div>
      </div>
      <div v-if="!displayContainerSokol" class="admin-code__section mt-4">
        <v-progress-linear v-if="loadingAutoCollect" indeterminate color="primary" class="mb-2" />
        <p class="text-body-2 mb-0">
          Режим автосбора ключей: <strong>{{ autoKeyMode }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { rules } from '../consts';
import { mapActions, mapGetters } from 'vuex';
import LCDSettings from '@/components/doorphone/EditDoorphone/components/LCDSettings';
import ServiceDoorCodeLifetime from '@/components/doorphone/EditDoorphone/components/ServiceDoorCodeLifetime';

export default {
  name: 'AdministrationCode',
  components: { LCDSettings, ServiceDoorCodeLifetime },
  props: ['returnDoorphone'],
  data: () => ({
    validDoors: true,
    textDoorphoneEnabled: true,
    isLoadingBtnMessage: true,
    loadingAutoCollect: true,
    rules,
    minServiceCode: 10000,
    maxServiceCode: 99999,
    minServiceCodeRubetekRV3434: 1000,
    maxServiceCodeRubetekRV3434: 9999999999,
    serviceDoorCode: '',
    servicePass: '',
    loadingServicePass: false,
    lifetimeDate: '',
    rotationEnabled: true,
    rotationComment: '',
    doorCodeRotateAt: null,
    textDoorphone: '',
    scanByCode: '',
    conciergeNumber: '',
    loadingConciergeNumber: false,
    conciergeNumberError: '',
    responseAutoKey: [],
    formDoors: {
      relay: [[], [], []],
      code: [],
    },
    doorKey: [
      '№1',
      '№2',
      '№3',
    ],
  }),
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
      textmessage: 'Doorphone/textmessage',
      agents: 'Agents/agents',
    }),
    displayContainerBeward () {
      return this.doorphoneEditInfo?.doorphone?.manufacturer === 'Beward';
    },
    displayContainerRubetekRV3434 () {
      return this.doorphoneEditInfo?.doorphone?.model === 'RV-3434';
    },
    displayContainerSokol () {
      return this.doorphoneEditInfo?.doorphone?.model === 'Sokol-Plus';
    },
    agentDispatcherPhone () {
      if (this.doorphone?.dispatcher_phone) {
        return this.doorphone.dispatcher_phone;
      }
      const agentId = this.doorphone?.agent_id;
      if (!agentId) {
        return '';
      }
      const agent = this.agents.find(item => item.id === agentId);
      return agent?.dispatcher_phone || '';
    },
    autoKeyMode () {
      if (!this.responseAutoKey || this.loadingAutoCollect) {
        return null;
      }

      if (this.responseAutoKey.data.status === false || this.responseAutoKey.data.data === null) {
        return 'Ошибка';
      }

      const dataAutoKey = this.responseAutoKey.data;

      if (this.displayContainerRubetekRV3434) {
        return dataAutoKey.activate ? 'Включен' : 'Выключен';
      }

      if (this.displayContainerBeward) {
        return dataAutoKey.auto_collect_keys === 'on' ? 'Включен' : 'Выключен';
      }

      return dataAutoKey.data.auto_collect_keys === 2 ? 'Включен' : 'Выключен';
    },
  },
  methods: {
    ...mapActions({
      loadAdminCodes: 'MainSetups/getAdminCodes',
      saveAdminCodes: 'MainSetups/updateAdminCodes',
      importCodesFromDoorphone: 'MainSetups/importCodesFromDoorphone',
      updateServiceDoorCode: 'Doorphone/updateServiceDoorCode',
      getServiceCode: 'Doorphone/getServiceCode',
      updateServiceCode: 'Doorphone/updateServiceCode',
      updateScanByCode: 'Doorphone/updateScanByCode',
      getTextMessage: 'Doorphone/getTextmessage',
      uploadTextMessage: 'Doorphone/uploadTextmessage',
      getAutoKeyCollection: 'Doorphone/getAutoKeyCollection',
      getConciergeNumber: 'Doorphone/getConciergeNumber',
      updateConciergeNumber: 'Doorphone/updateConciergeNumber',
    }),
    changeTextDoorphone () {
      if (this.textDoorphone === '') {
        this.$flash_danger('Укажите текст');
      } else {
        this.uploadTextMessage({
          text: this.textDoorphone,
          isEnabled: this.textDoorphoneEnabled,
          id: this.doorphone.id,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене текста на домофоне');
          });
      }
    },
    changeCodeBeward () {
      const serviceCode = this.serviceDoorCode.length;
      if (serviceCode < 1) {
        this.$flash_danger('Введите сервисный код');
        return;
      }
      if (serviceCode < 5) {
        this.$flash_danger('число должно быть 5-значным');
        return;
      }
      this.changeServiceCode();
    },
    changeOpeningCodeSokol () {
      const serviceCode = String(this.serviceDoorCode ?? '');
      if (serviceCode.length !== 5) {
        this.$flash_danger('Код открытия должен быть 5-значным');
        return;
      }
      this.changeServiceCode();
    },
    changeServicePass () {
      const pass = String(this.servicePass ?? '');
      if (pass.length !== 6) {
        this.$flash_danger('Сервисный код должен быть 6-значным');
        return;
      }
      this.loadingServicePass = true;
      this.updateServiceCode({
        id: this.$route.params.id,
        pass,
      })
        .then(() => {
          this.$flash_success('Сервисный код изменен');
        })
        .catch(() => {
          this.$flash_warning('Не удалось изменить сервисный код');
        })
        .finally(() => {
          this.loadingServicePass = false;
        });
    },
    loadServiceCode () {
      this.getServiceCode({ id: this.$route.params.id })
        .then((res) => {
          const pass = res?.pass ?? res?.data?.pass;
          this.servicePass = pass ? String(pass) : '';
        })
        .catch(() => {
          this.$flash_warning('Не удалось получить сервисный код');
        });
    },
    changeCodeRubetek3434 () {
      const serviceCode = this.serviceDoorCode.length;
      if (serviceCode < 1) {
        this.$flash_danger('Введите сервисный код');
        return;
      }
      if (serviceCode < 4 || serviceCode > 10) {
        this.$flash_danger('Число должно быть от 4 до 10 - значным');
        return;
      }
      this.changeServiceCode();
    },
    serviceCodeLifetimeField () {
      const names = [
        'serviceCodeLifetimeRv3438',
        'serviceCodeLifetimeBeward',
        'serviceCodeLifetimeRv3434',
        'serviceCodeLifetimeSokol',
      ];
      for (let i = 0; i < names.length; i += 1) {
        const field = this.$refs[names[i]];
        if (Array.isArray(field)) {
          const found = field.find(item => item && typeof item.snapshot === 'function');
          if (found) {
            return found;
          }
        } else if (field && typeof field.snapshot === 'function') {
          return field;
        }
      }
      return null;
    },
    serviceCodeLifetimePayload () {
      const field = this.serviceCodeLifetimeField();
      if (field && !field.validate()) {
        this.$flash_danger(field.validationError() || 'Проверьте поля обновления кода');
        return null;
      }
      if (field) {
        return field.snapshot();
      }
      const rotationLocked = !this.rotationEnabled;
      return {
        lifetimeDays: null,
        rotationLocked,
        rotationComment: rotationLocked ? String(this.rotationComment || '').trim() : '',
      };
    },
    changeServiceCode () {
      const lifetime = this.serviceCodeLifetimePayload();
      if (!lifetime) {
        return;
      }
      this.updateServiceDoorCode({
        id: this.$route.params.id,
        serviceDoorCode: this.serviceDoorCode,
        lifetimeDays: lifetime.lifetimeDays,
        rotationLocked: lifetime.rotationLocked,
        rotationComment: lifetime.rotationComment,
      })
        .then(() => {
          this.$flash_success('Сервисный код открытия двери успешно изменен');
          this.getAdminCodes();
        })
        .catch((error) => {
          const commentError = error?.response?.data?.errors?.rotation_comment?.[0];
          this.$flash_warning(commentError || 'Произошла ошибка во время изменения сервисного кода');
        });
    },
    changeScanByCode () {
      this.updateScanByCode({
        id: this.$route.params.id,
        scanByCode: this.scanByCode,
      })
        .then(() => {
          this.$flash_success('Код сканирования RFID успешно изменен');
        })
        .catch(() => this.$flash_warning('Произошла ошибка во время изменения кода'));
    },
    changeConciergeNumber () {
      if (!this.conciergeNumber || this.conciergeNumber.trim() === '') {
        this.$flash_danger('Введите номер консьержа');
        return;
      }
      this.loadingConciergeNumber = true;
      this.updateConciergeNumber({
        id: this.$route.params.id,
        conciergeNumber: this.conciergeNumber.trim(),
      })
        .then(() => {
          this.$flash_success('Номер консьержа успешно изменен на устройстве');
          this.loadConciergeNumber();
        })
        .catch(() => {
          this.$flash_warning('Произошла ошибка во время изменения номера консьержа на устройстве');
        })
        .finally(() => {
          this.loadingConciergeNumber = false;
        });
    },
    loadConciergeNumber () {
      this.conciergeNumberError = '';
      const dbNumber = this.doorphone?.concierge_number != null
        ? String(this.doorphone.concierge_number)
        : '';
      this.getConciergeNumber({ id: this.$route.params.id })
        .then((response) => {
          if (response && response.status === true) {
            const fromApi = response.conciergeNumber != null && String(response.conciergeNumber).trim() !== ''
              ? String(response.conciergeNumber)
              : '';
            this.conciergeNumber = fromApi || dbNumber;
            this.conciergeNumberError = '';
            return;
          }
          if (response && response.response && response.response.data && response.response.data.status === true) {
            const data = response.response.data;
            const fromApi = data.conciergeNumber != null && String(data.conciergeNumber).trim() !== ''
              ? String(data.conciergeNumber)
              : '';
            this.conciergeNumber = fromApi || dbNumber;
            this.conciergeNumberError = '';
            return;
          }
          this.conciergeNumber = dbNumber;
          if (response && response.status === false && response.error) {
            this.conciergeNumberError = response.error;
          }
        })
        .catch((error) => {
          this.conciergeNumber = dbNumber;
          if (error.response && error.response.data && error.response.data.error) {
            this.conciergeNumberError = error.response.data.error;
          }
        });
    },
    importCodes () {
      this.importCodesFromDoorphone({ id: this.$route.params.id })
        .then(res => {
          this.formDoors.relay = res.doors.map(door => door.relay.split(''));
          this.formDoors.code = res.doors.map(door => door.code);
          this.getAdminCodes();
          this.$flash_success('Импорт выполнен успешно');
        })
        .catch(error => {
          if (error.response && error.response.status === 400 && error.response.data.error) {
            this.$flash_warning(`Ошибка: ${error.response.data.error}`);
          } else {
            this.$flash_warning('Произошла ошибка во время импортирования из девайса');
          }
        });
    },
    validateCodeData () {
      this.formDoors.relay = this.formDoors.relay.map(relay => {
        relay.sort();
        return relay;
      });
      const lifetime = this.serviceCodeLifetimePayload();
      if (!lifetime) {
        return;
      }
      this.saveAdminCodes({
        id: this.$route.params.id,
        codeData: this.formDoors,
        lifetimeDays: lifetime.lifetimeDays,
        rotationLocked: lifetime.rotationLocked,
        rotationComment: lifetime.rotationComment,
      })
        .then(() => {
          this.$flash_success('Изменения сохранены');
          this.getAdminCodes();
        })
        .catch((error) => {
          const commentError = error?.response?.data?.errors?.rotation_comment?.[0];
          this.$flash_warning(commentError || 'Произошла ошибка во время сохранения кодов');
        });
    },
    rotationEnabledForCode (code, rotationLocked, rotateAt) {
      const protectedCode = ['1234', '1111', '12345'].includes(String(code ?? '').trim());
      if (protectedCode && !rotateAt) {
        return false;
      }
      return !rotationLocked;
    },
    assignment (res) {
      this.formDoors.relay = res.doors.map(door => (door.relay ? String(door.relay).split('') : []));
      this.formDoors.code = res.doors.map(door => door.code);
      this.serviceDoorCode = res.serviceDoorCode == null ? '' : String(res.serviceDoorCode);
      this.scanByCode = res.scanByCode;
      this.doorCodeRotateAt = res.doorCodeRotateAt || null;
      const rotationCode = this.doorphoneEditInfo?.doorphone?.model === 'RV-3438'
        ? res.doors?.[0]?.code
        : res.serviceDoorCode;
      this.rotationEnabled = this.rotationEnabledForCode(rotationCode, res.rotationLocked, this.doorCodeRotateAt);
      this.rotationComment = res.rotationComment || '';
    },
    getAdminCodes () {
      this.loadAdminCodes(this.$route.params.id)
        .then(res => {
          this.assignment(res);
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Произошла ошибка во время получения кодов');
          }
        });
    },
  },
  created () {
    if (this.displayContainerSokol) {
      this.loadServiceCode();
    }
    if (!this.displayContainerRubetekRV3434 && !this.displayContainerSokol) {
      this.isLoadingBtnMessage = true;
      this.getTextMessage(this.$route.params.id)
        .then(() => {
          const greetData = this.textmessage?.data || this.textmessage || {};
          this.textDoorphone = greetData.cGreetMsg || '';
          const enableRaw = String(greetData.cGreetEnable ?? '');
          this.textDoorphoneEnabled = enableRaw === '1';
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка получения настроек текста');
          }
        })
        .finally(() => {
          this.isLoadingBtnMessage = false;
        });
    }
    this.getAdminCodes();
    if (!this.displayContainerSokol) {
      this.loadConciergeNumber();
    }

    if (this.displayContainerSokol) {
      this.loadingAutoCollect = false;
      return;
    }

    this.getAutoKeyCollection(this.$route.params.id)
      .then((res) => {
        this.responseAutoKey = res;
      })
      .catch((error) => {
        console.error(error);
        this.responseAutoKey = null;
      })
      .finally(() => {
        this.loadingAutoCollect = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.admin-code__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.admin-code__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  display: flex;
  align-items: center;
}
.admin-code__form-row {
  margin: 0 -12px;
}
.admin-code__col {
  padding-top: 0;
  padding-bottom: 12px;
}
.admin-code__card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow: hidden;
}
.admin-code__card-body {
  padding: 16px;
}
.admin-code__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
